import { Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { Observable, map, switchMap } from 'rxjs';

import { Account } from '../../../auth/models/account.model';
import { Role } from '../../../auth/models/role.model';
import { User } from '../../../auth/models/user.model';
import { Company } from '../../../models/company.model';
import { TeamMember } from '../../../models/teamMember.model';
import { TeamService } from '../../../services/team.service';

@Component({
  selector: 'ag-team-users',
  templateUrl: './team-users.component.html',
  styleUrls: ['./team-users.component.scss']
})
export class TeamUsersComponent implements OnInit {

  @Input() public company: Company;
  @Input() public user: User;
  @Input() public account: Account;
  @ViewChild('agInvite', { static: false }) agInvite: any;

  public deletedMember = new EventEmitter();
  public processing: boolean;
  public selected: TeamMember[] = [];

  // Observables for async pipe
  public members$: Observable<TeamMember[]>;
  public roles$: Observable<Role[]>;
  public viewData$: Observable<{ members: TeamMember[]; roles: Role[] }>;

  constructor(
    private teamService: TeamService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    this.roles$ = this.teamService.getRoles();

    this.members$ = this.roles$.pipe(
      switchMap(() => this.teamService.get(this.company.id))
    );

    this.viewData$ = this.roles$.pipe(
      switchMap(roles =>
        this.teamService.get(this.company.id).pipe(
          map(members => ({ members, roles }))
        )
      )
    );
  }

  public edit(member: TeamMember): void {
    this.processing = true;
    this.teamService.edit(member).subscribe(() => {
      this.processing = false;
    });
  }

  /**
   * Removes the specified [[TeamMember|Team members]] from the {@link Company}.
   */
  public deleteMember(member: TeamMember): void {
    this.processing = true;
    this.teamService.delete(member).subscribe(() => {
      this.deletedMember.emit();
      this.deletedMember = new EventEmitter();
      this.loadData();
      this.processing = false;
    });
  }

  /** Reloads {@link Company} [[TeamMember|Team members]]. */
  public refresh(): void {
    this.loadData();
  }
}
